// Avis clients : uniquement de vrais avis publiés sur la fiche Google "Les Jardiniers Normands" (texte repris fidèlement, orthographe corrigée).
// Les auteurs sont abrégés (prénom et initiale). Ajouter ici de nouveaux avis réels, jamais de texte inventé.
export const TESTIMONIALS = [
  {
    name: "Claire R.",
    city: "Avis Google",
    date: "septembre 2026",
    rating: 5,
    text: "Personnes très agréables, très compétentes à l'écoute des clients. Ils interviennent très rapidement. Travail très bien exécuté.",
  },
  {
    name: "Maxence D.",
    city: "Avis Google",
    date: "août 2026",
    rating: 5,
    text: "Merci infiniment pour la taille de mes pommiers et oliviers. Les équipes d'Antony ont été à mon écoute. Vous êtes de bons paysagiste à Caen. Très sérieux !",
  },
  {
    name: "Hélène D.",
    city: "Avis Google",
    date: "août 2026",
    rating: 5,
    text: "Super découverte, personne très gentil, nous a proposé un devis qui était plus que satisfaisant et travaux réalisés avec soins et propreté.",
  },
  {
    name: "David B.",
    city: "Avis Google",
    date: "août 2026",
    rating: 5,
    text: "J'ai fait appel à ce jardinier qui fait des travaux de taille de haie sur la commune de Caen, je suis super satisfait du travail.",
  },
  {
    name: "Stéphane L.",
    city: "Avis Google",
    date: "mai 2026",
    rating: 5,
    text: "J'ai contacté cet artisan pour des travaux de jardinage chez moi, je recommande sans hésitation, très professionnel, réactif et prix compétitif.",
  },
  {
    name: "Cassandra L.",
    city: "Avis Google",
    date: "mai 2026",
    rating: 5,
    text: "Cette entreprise est passée ce matin chez moi pour un entretien de mon jardin, travail nickel, je le recommande.",
  },
];
